/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { wordTimingSchema } from '../shared/word-timing-schema';

export const getTitleAudioCachedV1ResultSchema = z.discriminatedUnion('exists', [
  z.object({ exists: z.literal(false) }),
  z.object({
    exists: z.literal(true),
    value: z.object({
      audioUrl: z.string(),
      wordTimings: z.array(wordTimingSchema).optional(),
    }),
  }),
]);

export type IGetTitleAudioCachedV1Result = z.infer<typeof getTitleAudioCachedV1ResultSchema>;

export const getTitleAudioCachedV1ResponseSchema = createApiResponseSchema(
  getTitleAudioCachedV1ResultSchema,
) as z.ZodSchema<IAPI<IGetTitleAudioCachedV1Result>>;

export type IGetTitleAudioCachedV1Response = IAPI<IGetTitleAudioCachedV1Result>;
